export default __webpack_public_path__ + "static/media/2007.7c582f7c.png";